import appMoment from 'moment';
import 'moment/locale/tr';

appMoment.locale('tr');

export default appMoment;
